<template>
  <div class="login-modal-inner">

    <!-- Branded Header -->
    <div class="login-brand-header">
      <img src="../../icons/Logo.svg" alt="Renants" class="login-brand-logo" />
      <p class="login-brand-tagline">Your local community marketplace</p>
    </div>

    <div class="login-form-body">
    <p class="title">
      <span v-if="actionType === 'contact'">Verify to View Contact</span>
      <span v-else-if="actionType === 'favorite'">Sign in to Save Favorites</span>
      <span v-else>Verify to Send Message</span>
    </p>
    <p class="subtitle">
      <span v-if="actionType === 'contact'">
        To view contact details, please verify your email.
      </span>
      <span v-else-if="actionType === 'favorite'">
        Save listings to your favorites and find them again from any device.
      </span>
      <span v-else>
        To send a message, please verify your email.
      </span>
    </p>
    <input type="email" v-model="email" placeholder="Enter your email" />

    <div v-if="step === 0">
      <button class="btn-primary" :disabled="busy" @click="checkUser">
        <span v-if="checking" class="spinner"></span>
        <span v-else>Continue</span>
      </button>
    </div>

    <!-- Existing user: show password box -->
    <div v-if="step === 1">
      <div class="password-wrapper modern-password-box">
        <input
          :type="showPassword ? 'text' : 'password'"
          v-model="password"
          placeholder="Password"
        />
        <span class="toggle-password" @click="togglePassword">
          <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
        </span>
      </div>
      <button class="btn-primary" :disabled="busy" @click="handleLogin(this.service)">
        <span v-if="submitting" class="spinner"></span>
        <span v-else>{{ ctaLabel }}</span>
      </button>
    </div>

    <!-- New user: show info and continue to message panel -->
    <div v-if="step === 2">
      <div class="new-user-info">
        <p>Thank you for signing up!<br /> <a href="/reset-password" @click="gotopass()">Click here</a> to reset your password and get started.</p>
      </div>
      <button
  class="btn-primary"
  @click="gotomessagepanel(service)"
  :disabled="busy"
>
  <span v-if="loading || submitting" class="spinner"></span>
  <span v-else>{{ ctaLabel }}</span>
</button>

    </div>

    <div class="divider">
      <span></span>
      <p>or continue with</p>
      <span></span>
    </div>

    <!-- Social Icon Buttons -->
    <div class="social-icons-row">
      <button class="btn-social-icon btn-google-icon" :disabled="busy" @click="handleGoogleLogin" title="Continue with Google">
        <span v-if="googleLoading" class="spinner spinner-dark"></span>
        <svg v-else width="32" height="32" viewBox="0 0 48 48">
          <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
          <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
          <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.18 1.48-4.97 2.31-8.16 2.31-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
        </svg>
      </button>
      <!-- <button class="btn-social-icon btn-facebook-icon" @click="handleFacebookLogin" title="Continue with Facebook">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="#1877F2">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      </button> -->
      <button class="btn-social-icon btn-email-icon" :disabled="busy" @click="$emit('switchMode', 'emailLink')" title="Login with Email link">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="4" width="20" height="16" rx="2"/>
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
        </svg>
      </button>
    </div>
    <!-- <div style="justify-content: center; text-align: center;">
<span class="forgot" @click="$emit('switchMode', 'forgot')"
        >Forgot Password?</span
      >
    </div> -->
     
    <div class="switch-box">
      <span>Don't have an account?</span>
      <span class="forgot" @click="$emit('switchMode', 'register')">
        Create New Account</span
      >
    </div>
    <FloatingView
      v-if="showFloating && selectedService"
      :service="selectedService"
      @close="closeFloating"
    />
    </div><!-- end login-form-body -->
  </div>
</template>

<script>
import axios from "axios";
import { toast } from "vue-sonner";
import { API_ORIGIN, IS_NATIVE } from "@/config/apiBase";
import { openExternal } from "@/utils/native";

import { UAParser } from "ua-parser-js";
import FloatingView from "../SendResponse.vue";
import { EventBus } from "@/services/EventBus.js";
import { getRecaptchaToken } from "@/utils/recaptcha";
import { randomPassword } from "@/utils/randomPassword";
import { trackLogin } from "@/utils/trackPageVisit";


export default {
  components: {
    FloatingView,
  },
  inject: ["refreshApp"],
  data() {
    return {
      email: "",
      password: "",
      remember: false,
      showPassword: false,
      step: 0, // 0: email, 1: existing user (password), 2: new user
      showFloating: false,
      selectedService: null,
          loading: false,
      // Double-submit guards, one per button: `checking` = Continue,
      // `submitting` = View Contact / Send Message, `googleLoading` = Google
      // redirect. `loading` stays as-is for createAndSendLink.
      checking: false,
      submitting: false,
      googleLoading: false,
    };
  },
props: {
  service: {
    type: Object,
    required: true
  },
  actionType: {
    type: String,
    default: ""
  }
},
  computed: {
    // Any in-flight action disables every button in the modal.
    busy() {
      return this.loading || this.checking || this.submitting || this.googleLoading;
    },
    // Label on the submit buttons — names the action the user was trying to
    // take before we interrupted them for a sign-in.
    ctaLabel() {
      if (this.actionType === "contact") return "View Contact";
      if (this.actionType === "favorite") return "Save to Favorites";
      return "Send Message";
    },
  },
  mounted() {
    this.trackVisitor();
    this.loadGoogleAnalytics();

  console.log("Service data:", this.service);
  console.log("Service ID:", this.service?.servicesID);
  console.log("User ID:", this.service?.userID);
  // Access properties like this.service.servicesName, this.service.userID, etc.

  },

  methods: {
    async trackVisitor() {
      const parser = new UAParser();
      const browserInfo = parser.getResult();

      const visitData = {
        timestamp: new Date().toISOString(),
        browser: browserInfo.browser.name,
        browserVersion: browserInfo.browser.version,
        os: browserInfo.os.name,
        osVersion: browserInfo.os.version,
        device: browserInfo.device.type || "Desktop",
        pageName: "Login Page",
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      try {
        const response = await fetch("https://api64.ipify.org?format=json");
        const { ip } = await response.json();
        visitData.ip = ip;

        await fetch("/api/visitors", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(visitData),
        });
      } catch (error) {
        console.error("Error tracking visitor:", error);
      }
    },

    loadGoogleAnalytics() {
      const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID;
      if (!gaId) return Promise.resolve();
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(script);

      return new Promise((resolve, reject) => {
        script.onload = () => {
          window.dataLayer = window.dataLayer || [];
          window.gtag = (...args) => window.dataLayer.push(args);
          window.gtag("js", new Date());
          window.gtag("config", gaId);
          resolve();
        };

        script.onerror = () => {
          console.error("Failed to load Google Analytics.");
          reject(new Error("GA script load failed"));
        };
      });
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    async checkUser() {
      if (this.busy) return;
      if (!this.email) {
        toast.error("Please enter an email.");
        return;
      }
      this.checking = true;
      try {
        // Check if user exists
           const res = await axios.post("/api/getoneusers", {
            email: this.email,
          });
        if (res.data.length >= 1)  {
          this.step = 1;
        } else {
          this.step = 2;
          this.createAndSendLink();
        }
      } catch (err) {
        toast.error("Error checking user. Please try again.");
      } finally {
        this.checking = false;
      }
    },

  gotomessagepanel() {
    if (this.busy) return;
    // Stays set — the modal is handing off to the message panel / contact view.
    this.submitting = true;
    this.$emit("loginSuccess", this.service, this.actionType);
    EventBus.notifyGlobalLogin();
  },
    gotopass()  {
      this.$router.push("/reset-password");
    },
       openFloating(service) {
  this.selectedService = service;
  this.showFloating = true;
},
 closeFloating() {
      this.showFloating = false;
      this.selectedService = null;
    },

    async handleLogin(service) {
      if (this.busy) return;
      if (!this.password) {
        toast.error("Please enter your password.");
        return;
      }
      this.submitting = true;
      try {
        const recaptchaToken = await getRecaptchaToken('login');
        const authRes = await axios.post("/api/authenticate", {
          email: this.email,
          secKey: this.password,
          recaptchaToken,
        });
        if (authRes.data && authRes.status === 200) {
          toast.success("Login successful 🎉");
          localStorage.setItem("auth-token", authRes.data.token);
          const userid = authRes.data.userID;
          const username = authRes.data.userName;
          const logintime = new Date().toISOString();
          localStorage.setItem("userid", userid);
          localStorage.setItem("logintime", logintime);
          // Emit event and notify global login immediately for fast UI
          this.$emit("loginSuccess", this.service, this.actionType);
          EventBus.notifyGlobalLogin();
          // Run logging/reporting in background (do not await)
          (async () => {
            try {
              // First, so the report survives a navigation triggered by loginSuccess.
              await trackLogin("Email", { userID: userid, userName: username });
              const userlogRes = await axios.post("/api/userlog", {
                userID: userid,
                loginTime: logintime,
                status: "active",
              });
              const userlogid = userlogRes.data.item.userlogId;
              localStorage.setItem("userlogid", userlogid);
              await axios.put("/api/updateoneuser", {
                userID: userid,
                status: "active",
              });
            } catch (e) {
              // Logging/reporting errors are non-blocking
              // Optionally log error: console.error(e);
            }
          })();
        } else {
          toast.error("Invalid email or password");
          this.submitting = false;
        }
      } catch (err) {
        toast.error("Login failed! Please try again");
        this.submitting = false;
      }
      // On success `submitting` stays set — the modal is handing off via
      // loginSuccess and must not accept a second click on the way out.
    },
       isValidEmail(email) {
      return /\S+@\S+\.\S+/.test(email);
    },
async completeLogin(email, password) {
  try {
    const recaptchaToken = await getRecaptchaToken('login');
    const authRes = await axios.post("/api/authenticate", {
      email,
      secKey: password,
      recaptchaToken,
    });

      if (authRes.data && authRes.status === 200) {
          toast.success("Login successful 🎉");

          localStorage.setItem("auth-token", authRes.data.token);
          const userid = authRes.data.userID;
          const username = authRes.data.userName;
          const logintime = new Date().toISOString();

          localStorage.setItem("userid", userid);
          localStorage.setItem("logintime", logintime);

          const userlogRes = await axios.post("/api/userlog", {
            userID: userid,
            loginTime: logintime,
            status: "active",
          });
          const userlogid = userlogRes.data.item.userlogId;
          localStorage.setItem("userlogid", userlogid);

          await axios.put("/api/updateoneuser", {
            userID: userid,
            status: "active",
          });
      
          await trackLogin("Email Link", { userID: userid, userName: username });
    
        } else {
          toast.error("Invalid email or password");
        }

    // this.$emit("loginSuccess", this.service);

  } catch (err) {
    toast.error("Auto login failed.");
  }
},


    async createAndSendLink() {
      if (this.loading) return;
      this.loading = true;
      if (!this.isValidEmail(this.email)) {
        toast.error("Invalid email address.");
        this.loading = false;
        return;
      }

      try {
        const email = this.email.trim();

        // add guest
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const guestResponse = await axios.post("/api/addguest", {
          email,
          timezone,
        });
        if (guestResponse.status !== 200) {
          throw new Error("Guest creation failed");
        }

        // check exists
        const checkResponse = await axios.post("/api/getoneusers", { email });

        if (checkResponse.data.length >= 1) {
          // Existing account: we can't sign them in without proof they own
          // the inbox (this used to log in with the shared "TempPass123").
          await this.sendLoginLink(email);
        } else {
          const password = randomPassword();
          if (await this.verifyLogin(email, password)) {
            await this.completeLogin(email, password);
          }
        }

      } catch (error) {
        console.error(error);
        toast.error("Failed to send login link.");
      }
 finally {
    this.loading = false; 
  }
      
   
      
      },
      
        // New account with a random throwaway password; the emailed reset
    // link lets them set a real one. Returns true when registration succeeded.
        async verifyLogin(email, password) {
      const username = email.split("@")[0];

      const recaptchaToken = await getRecaptchaToken('register');
      const registerResponse = await axios.post("/api/register", {
        userName: username,
        email,
        secKey: password,
        orgInfo: "Temp",
        recaptchaToken,
      });

      if ([200, 201].includes(registerResponse.status)) {
        await this.sendSetPasswordLink(email);
        return true;
      }
      return false;
    },
    async sendSetPasswordLink(email) {
      try {
        const recaptchaToken = await getRecaptchaToken('reset_link');
        const res = await axios.post("/api/send-resetlink", { email, recaptchaToken });
        if (res?.data?.failed || res?.data?.skipped) {
          toast.error("Email could not be sent. Please try again later.");
        }
      } catch (err) {
        toast.error("Failed to send the set-password email.");
      }
    },
    async sendLoginLink(email) {
      try {
        const recaptchaToken = await getRecaptchaToken('email_link');
        const res = await axios.post("/api/send-emaillink", { email, recaptchaToken });
        if (res?.data?.failed || res?.data?.skipped) {
          toast.error("Email could not be sent. Please try again later.");
        } else {
          toast.success(`You already have an account. We sent a sign-in link to ${email}.`);
          this.$emit("close");
        }
      } catch (err) {
        toast.error("Failed to send login link.");
      }
    },
    handleGoogleLogin() {
      if (this.busy) return;
      this.googleLoading = true;
      const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
      // In dev mode, frontend (Vite) and backend (Express) are on different ports
      // Use backend URL for OAuth redirect so the callback reaches the Express server
      const isDev = import.meta.env.DEV;
      // Native app: window.location.origin is capacitor://localhost — use the
      // real backend origin. (Phase 3 replaces this flow with native sign-in.)
      const backendOrigin = isDev ? 'http://localhost:4000' : (API_ORIGIN || window.location.origin);
      const redirectUri = backendOrigin + '/auth/google/callback';
      const scope = 'profile email';
      
      // Store the current path so we can redirect back after login
      const currentPath = this.$route?.fullPath || window.location.pathname;
      if (currentPath && currentPath !== '/') {
        localStorage.setItem('redirectTo', currentPath);
      }
      
      // Build OAuth URL and redirect the main window (no popup). state=native
      // tells the backend callback to redirect to the app's deep link
      // (com.renants.app://auth) instead of the web origin.
      const oauthUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${googleClientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=${encodeURIComponent(scope)}&prompt=select_account${IS_NATIVE ? '&state=native' : ''}`;

      if (IS_NATIVE) {
        // In-app browser (SFSafariViewController / Custom Tabs) — the deep-link
        // listener in App.vue closes it when the token arrives. Navigating the
        // WebView itself would bounce the user out to Safari with no way back.
        openExternal(oauthUrl);
        this.googleLoading = false;
        return;
      }
      // Redirect the main window to Google OAuth
      window.location.href = oauthUrl;
    },
    handleFacebookLogin() {
      const facebookAppId = import.meta.env.VITE_FACEBOOK_APP_ID || 'YOUR_FACEBOOK_APP_ID';
      const redirectUri = window.location.origin + '/auth/facebook/callback';
      const scope = 'email,public_profile';
      const oauthUrl = `https://www.facebook.com/v18.0/dialog/oauth?client_id=${facebookAppId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=${encodeURIComponent(scope)}&auth_type=rerequest`;
      const width = 500, height = 600;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2;
      window.open(oauthUrl, 'FacebookLogin', `width=${width},height=${height},left=${left},top=${top}`);
      let handled = false;
      const messageHandler = async (event) => {
        if (event.origin !== window.location.origin || handled) return;
        handled = true;
        if (event.data && event.data.type === 'facebook-auth-success') {
          localStorage.setItem('auth-token', event.data.token);
          try {
            const userRes = await axios.post('/api/getoneusers', {}, { headers: { Authorization: `Bearer ${event.data.token}` } });
            if (userRes.data && userRes.data.item) {
              localStorage.setItem('userid', userRes.data.item.userID);
              await trackLogin('Facebook', { userID: userRes.data.item.userID, userName: userRes.data.item.userName });
            }
          } catch (e) {}
          this.$emit('close');
          window.location.reload();
        } else if (event.data && event.data.type === 'auth-error') {
          toast.error(event.data.message || 'Login failed');
          this.$emit('close');
        }
        window.removeEventListener('message', messageHandler);
      };
      window.addEventListener('message', messageHandler);
      setTimeout(() => { if (!handled) { handled = true; toast.error('Login timed out. Please try again.'); this.$emit('close'); window.removeEventListener('message', messageHandler); } }, 60000);
    },
  }


};
</script>
<style scoped>
/* ── Brand Header ── */
.login-brand-header {
  background: linear-gradient(135deg, #1d3fa8 0%, #3467d5 60%, #5b87f0 100%);
  border-radius: 14px 14px 0 0;
  padding: 22px 24px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}
.login-brand-logo {
  height: 32px;
  filter: brightness(0) invert(1);
}
.login-brand-tagline {
  color: rgba(255,255,255,0.75);
  font-size: 12px;
  font-family: var(--font-primary);
  margin: 0;
}

/* ── Form Body ── */
.login-form-body {
  padding: 24px 24px 20px;
}

.title {
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 4px;
  color: var(--color-text-primary);
  font-family: var(--font-primary);
}
.subtitle {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0 0 16px;
  font-family: var(--font-primary);
}

input[type="email"],
input[type="password"],
input[type="text"] {
  width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  border: 1.5px solid #e2e8f0;
  margin-bottom: 14px;
  font-size: 14px;
  font-family: var(--font-primary);
  background: #f8faff;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;
  outline: none;
}
input[type="email"]:focus,
input[type="password"]:focus,
input[type="text"]:focus {
  border-color: #3467d5;
  box-shadow: 0 0 0 3px rgba(52,103,213,0.12);
  background: #fff;
}

.btn-primary {
  background: linear-gradient(135deg, #1d3fa8 0%, #3467d5 60%, #5b87f0 100%);
  color: white;
  width: 100%;
  padding: 11px 18px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 15px;
  margin-bottom: 12px;
  font-weight: 700;
  font-family: var(--font-primary);
  transition: opacity 0.2s;
}
.btn-primary:hover { opacity: 0.92; }
.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }

.password-wrapper {
  position: relative;
}
.password-wrapper input {
  padding-right: 42px;
}
.toggle-password {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-65%);
  cursor: pointer;
  color: #94a3b8;
  font-size: 18px;
}
.toggle-password:hover { color: #3467d5; }

.divider {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  color: #94a3b8;
  font-size: 12px;
  font-family: var(--font-primary);
}
.divider span { flex: 1; height: 1px; background: #e9eef6; }
.divider p { margin: 0 10px; white-space: nowrap; }

.forgot {
  color: #3467d5;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  font-family: var(--font-primary);
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.forgot:hover { color: #1d3fa8; text-decoration: underline; }

.login-links {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 13px;
  color: var(--color-text-secondary);
}
.center-links { justify-content: center !important; }

/* ── Social Icon Buttons ── */
.social-icons-row {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
}
.btn-social-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 1.5px solid #e2e8f0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.15s;
}
.btn-social-icon:hover {
  border-color: #c7d2e8;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}
.btn-social-icon:disabled,
.btn-social-icon:disabled:hover {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
  border-color: #e2e8f0;
}

.switch-box {
  display: flex;
  justify-content: center;
  gap: 5px;
  font-size: 13px;
  font-family: var(--font-primary);
  color: var(--color-text-secondary);
}

.new-user-info {
  background: #f0f6ff;
  border: 1px solid #bfd4fe;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 14px;
  color: #1a3a5d;
  font-size: 14px;
  font-family: var(--font-primary);
}
.new-user-info p { margin: 0; }
.new-user-info a { color: #3467d5; font-weight: 600; }

.modern-password-box {
  background: #f8faff;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  padding: 2px 12px 2px 2px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
}
.modern-password-box input {
  border: none;
  background: transparent;
  flex: 1;
  font-size: 14px;
  outline: none;
  padding: 10px 12px;
  margin-bottom: 0;
}
.modern-password-box .toggle-password {
  font-size: 18px;
  color: #94a3b8;
  margin-left: 4px;
  transform: none;
  position: static;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2.5px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  display: inline-block;
  animation: spin 0.7s linear infinite;
  vertical-align: middle;
}
/* Used inside the white circular social buttons, where a white ring is invisible */
.spinner-dark {
  width: 22px;
  height: 22px;
  border-color: rgba(52, 103, 213, 0.25);
  border-top-color: #3467d5;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>
